import { useMutation, useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query';
import { SessionService } from '../session.service';
import { ServiceService } from '../service.service';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@/utils/errorMessage';

export const useGetSessions = (
	params: Sessions.SessionParams & { isMe?: boolean },
	options?: Omit<
		UseQueryOptions<Sessions.GetSessionsRespose, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	const {
		payment,
		status,
		statusList,
		type,
		patient_id,
		limit,
		page,
		date_a,
		date_b,
		search,
		role,
		targetID,
		sort,
		sort_direction,
		isMe,
	} = params;

	return useQuery({
		queryKey: [
			'sessions',
			isMe,
			payment,
			status,
			statusList,
			type,
			patient_id,
			search,
			role,
			targetID,
			sort,
			sort_direction,
			limit,
			page,
			date_a,
			date_b,
		],
		queryFn: () => {
			const { isMe, ...queryParams } = params;
			return isMe
				? SessionService.getMe(queryParams)
				: SessionService.get(queryParams);
		},
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useFetchServiceByServiceName = () => {
	return useMutation({
		mutationFn: (serviceName: string) =>
			ServiceService.getByServiceName(serviceName),
		onError: (error: unknown) => {
			toast.error(
				getErrorMessage(
					error,
					'Erro ao buscar o serviço correspondente.',
				),
			);
		},
	});
};

export const useGetSession = (
	id: string,
	options?: Omit<
		UseQueryOptions<Sessions.Session, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['session', id],
		queryFn: () => {
			return SessionService.getById(id);
		},
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetSessionPosProcessingStatus = (
	id: string,
	options?: Omit<
		UseQueryOptions<Sessions.PosProcessingStatus, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['session-pos-processing', id],
		queryFn: () => SessionService.getPosProcessingStatus(id),
		refetchOnWindowFocus: false,
		refetchInterval: (query) => (query.state.data?.is_done ? false : 4000),
		...options,
	});
};

export const useGetSessionVideoRoom = (
	id: string,
	options?: Omit<
		UseQueryOptions<SessionCall.Credentials, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['session-video-room', id],
		queryFn: () => {
			return SessionService.getVideoRoom(id);
		},
		enabled: !!id,
		refetchOnWindowFocus: false,
		...options,
	});
};

// export const useGetCheckoutUrl = () => {
// 	return useMutation({
// 		mutationFn: (sessionId: string) => SessionService.getCheckoutUrl(sessionId),

// 		onSuccess: data => {
// 			if (data && data.url) {
// 				window.location.replace(data.url);
// 			} else {
// 				console.error("A URL de checkout não foi recebida do servidor.");
// 				alert("Ocorreu um erro ao buscar o link de pagamento.");
// 			}
// 		},

// 		onError: error => {
// 			console.error("Falha ao buscar a URL de checkout:", error);
// 			alert(
// 				"Não foi possível iniciar o pagamento. Por favor, tente novamente."
// 			);
// 		}
// 	});
// };

// export const usePayWithAbacate = () => {
// 	return useMutation({
// 		mutationFn: (sessionId: string) => SessionService.payWithAbacate(sessionId),

// 		// A lógica de sucesso é idêntica: redirecionar para a URL recebida
// 		onSuccess: data => {
// 			if (data && data.url) {
// 				window.location.replace(data.url);
// 			} else {
// 				console.error("A URL de pagamento PIX não foi recebida do servidor.");
// 				alert("Ocorreu um erro ao buscar o link de pagamento PIX.");
// 			}
// 		},

// 		onError: error => {
// 			console.error("Falha ao buscar a URL de pagamento PIX:", error);
// 			alert(
// 				"Não foi possível iniciar o pagamento PIX. Por favor, tente novamente."
// 			);
// 		}
// 	});
// };

// export const usepayWithCredit = () => {
// 	const queryClient = useQueryClient();
// 	return useMutation<{ success: boolean; message: string }, Error, string>({
// 		mutationFn: (sessionId: string) => SessionService.payWithCredit(sessionId),
// 		onSuccess: data => {
// 			queryClient.invalidateQueries({ queryKey: ["user"] });
// 			queryClient.invalidateQueries({ queryKey: ["sessions"] });
// 		},
// 		onError: error => {
// 			console.error("Resposta inválida do servidor:", error);
// 		}
// 	});
// };
